import React, { useState, useEffect } from 'react';
import { PagoClienteService } from '../../services/pagoClienteService.js';
import PagoClienteForm from './PagoClienteForm';
import PagoClienteItem from './PagoClienteItem';
import { MESSAGES } from '../../utils/constants';
import theme, { cn } from '../../styles/theme';

const PagoClienteList = ({ sucursalId, sucursalNombre, onBack }) => {
  const [pagoc, setPagoc] = useState([]);  
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingPagoc, setEditingPagoc] = useState(null);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);
  const [showSucursales, setShowSucursales] = useState(false);
  const [pagocSeleccionada, setPagocSeleccionada] = useState(null);

  useEffect(() => {
    loadPagoc();
  }, []);

  const loadPagoc = async () => {
    setLoading(true);
    try {
      const data = await PagoClienteService.getAllPa(sucursalId, true);
      setPagoc(data);
    } catch (error) {
      showMessage('danger', MESSAGES.ERROR.GENERIC);
    }
    setLoading(false);
  };

  
  const handleBackToPagoc = () => {
    setShowSucursales(false);
    setPagocSeleccionada(null);
  };

  const testConnection = async () => {
    console.log('🧪 Iniciando test de conexión...');
    await PagoClienteService.testConnection();
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: '', text: '' }), 5000);
  };

  const handleCreate = () => {
    setEditingPagoc(null);
    setShowForm(true);
  };

  const handleEdit = (pagoc) => {
    console.log('🔍 === HANDLE EDIT DEBUG ===');
    console.log('🔍 PagoCliente recibido en handleEdit:', pagoc);
    
    setEditingPagoc(pagoc);
    setShowForm(true);
  };

  const handleFormSubmit = async (Data) => {
    setLoading(true);
    console.log('DEBUG handleFormSubmit:', Data);
    
    try {
      Data.Id_sucursal = sucursalId;
      
      if (editingPagoc) {
        console.log('ID para actualizar:', editingPagoc.Id_pagoc);
        await PagoClienteService.update(editingPagoc.Id_pagoc, Data);
        showMessage('success', MESSAGES.SUCCESS.UPDATE);
      } else {
        await PagoClienteService.create(Data);
        showMessage('success', MESSAGES.SUCCESS.CREATE);
      }
      
      setShowForm(false);
      setEditingPagoc(null);
      await loadPagoc();
    } catch (error) {
      showMessage('danger', MESSAGES.ERROR.GENERIC);
    }
    setLoading(false);
  };

  const handleDelete = (Id_pagoc) => {
    setRoleToDelete(Id_pagoc);
    setShowDeleteModal(true);
  };

  
  const handleCancel = () => {
    setShowForm(false);
    setEditingPagoc(null);
  };

  const MessageAlert = ({ message, onClose }) => {
    if (!message.text) return null;

    const getAlertStyles = () => {
      switch (message.type) {
        case 'success':
          return 'bg-green-50 border-green-200 text-green-800';
        case 'danger':
          return 'bg-red-50 border-red-200 text-red-800';
        case 'warning':
          return 'bg-yellow-50 border-yellow-200 text-yellow-800';
        default:
          return 'bg-blue-50 border-blue-200 text-blue-800';
      }
    };

    const getIcon = () => {
      switch (message.type) {
        case 'success':
          return (
            <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          );
        case 'danger':
          return (
            <svg className="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          );
        default:
          return (
            <svg className="w-5 h-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          );
      }
    };

    return (
      <div className={cn("border-l-4 p-4 mb-6 rounded-r-lg", getAlertStyles())}>
        <div className="flex items-start justify-between">
          <div className="flex items-start">
            <div className="mr-3 mt-0.5">{getIcon()}</div>
            <p className="font-medium">{message.text}</p>
          </div>
          <button
            onClick={onClose}
            className={cn("ml-4 text-gray-400 hover:text-gray-600", theme.transitions.default)}
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    );
  };

  

  if (showForm) {
    return (
      <div className={cn("min-h-screen py-8", theme.classes.background.main)}>
        <PagoClienteForm
          pagoc={editingPagoc}
          onSubmit={handleFormSubmit}
          onCancel={handleCancel}
          isLoading={loading}          
          sucursalId={sucursalId}
          sucursalNombre={sucursalNombre}
        />
      </div>
    );
  }

  return (
    <div className={cn("min-h-screen p-6", theme.classes.background.main)}>
      <div className="max-w-7xl mx-auto">
        <div className={cn(theme.classes.card.base, "p-6 mb-6")}>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className={cn(theme.classes.iconBox.primary, "p-3", theme.shadows.lg)}>
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4-8-4m16 0v10l-8 4-8-4V7" />
                </svg>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Gestión de Pago Cliente</h1>
                <p className="text-gray-600 mt-1">
                  Sucursal: <span className="font-semibold text-gray-900">{sucursalNombre}</span>
                </p>
                <p className="text-sm text-gray-500">Administra los Pago de Cliente del sistema</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              {onBack && (
                <button
                  onClick={onBack}
                  className={cn(theme.classes.button.secondary, "px-4 py-2 rounded-lg font-medium flex items-center gap-2", theme.transitions.default)}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  Volver
                </button>
              )}
              
              <button
                onClick={testConnection}
                className={cn("px-4 py-2 text-gray-700 border-2 border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 font-medium flex items-center gap-2", theme.transitions.default)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                Test API
              </button>
              
              <button
                onClick={handleCreate}
                className={cn(theme.classes.button.primary, "px-6 py-3 font-semibold rounded-lg transform hover:-translate-y-0.5 flex items-center gap-2", theme.transitions.default)}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                </svg>
                Crear Nuevo Pago
              </button>
            </div>
          </div>
          
          <div className="mt-6 pt-6 border-t border-gray-200">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="flex items-center gap-3">
                <div className={theme.classes.iconBox.success}>
                  <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Total de Pagos</p>
                  <p className="text-2xl font-bold text-gray-900">{pagoc.length}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className={theme.classes.iconBox.info}>
                  <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Pagos Activos</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {pagoc.filter(p => p.Estado === 'ACTIVO').length}
                  </p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className={theme.classes.iconBox.warning}>
                  <svg className="w-5 h-5 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Pagos Inactivos</p>
                  <p className="text-2xl font-bold text-gray-900">
                    {pagoc.filter(p => p.Estado === 'INACTIVO').length}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <MessageAlert 
          message={message} 
          onClose={() => setMessage({ type: '', text: '' })} 
        />

        <div className={cn(theme.classes.card.base, "overflow-hidden")}>
          {loading && !showForm ? (
            <div className="flex items-center justify-center py-20">
              <div className="text-center">
                <svg className="animate-spin h-12 w-12 text-gray-900 mx-auto mb-4" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <p className="text-lg font-medium text-gray-900">Cargando Pagos...</p>
                <p className="text-gray-600 mt-1">Por favor espera un momento</p>
              </div>
            </div>
          ) : pagoc.length === 0 ? (
            <div className="text-center py-20">
              <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4-8-4m16 0v10l-8 4-8-4V7" />
              </svg>
              <h3 className="text-lg font-medium text-gray-900 mb-2">No hay Pagos disponibles</h3>
              <p className="text-gray-600 mb-6">Comienza creando tu primer pagos en esta sucursal</p>
              <button
                onClick={handleCreate}
                className={cn(theme.classes.button.primary, "px-6 py-3 rounded-lg font-medium", theme.transitions.default)}
              >
                Crear Primer Pago
              </button>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">ID</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Imagen</th>                    
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Descripcion</th>          
                    <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Acciones</th>
                  </tr>
                </thead>
                <tbody className={cn(theme.classes.background.card, "divide-y divide-gray-200")}>
                  {pagoc.map(pagoc => (
                    <PagoClienteItem
                      key={pagoc.Id_pagoc}
                      pagoc={pagoc}
                      onEdit={handleEdit}
                     
                    />
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

       
      </div>
    </div>
  );
};

export default PagoClienteList;